import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import TableComponent from './Tablecomponent';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Breadcrumbs, Button, Divider, Grid, Paper, Tooltip, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import labels from '../../img/labels.svg'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import rupee from '../../img/rupee.svg'
import rupee1 from '../../img/rupee1.svg'
import currentbalance from '../../img/currentbalance.svg'
import PayoutModal from '../studio/cardformate/PayoutModal';
import ApiService from '../../_services/ApiService';
import { setLoader } from '../../redux';
import dayjs from 'dayjs';

const getStatusChipStyle = (status) => {
    switch (status) {
        case 'Paid':
            return { backgroundColor: 'rgba(76, 175, 80, 0.18) !Important', color: '#2E7D32' };
        case 'On-Hold':
            return { backgroundColor: 'rgba(255, 152, 0, 0.2) !Important', color: '#E65100' };
        case 'Requested':
            return { backgroundColor: 'rgba(33, 150, 243, 0.18) !Important', color: '#0D47A1' };
        case 'Rejected':
            return { backgroundColor: 'rgba(244, 67, 54, 0.18) !Important', color: '#B71C1C' };
        default:
            return { backgroundColor: 'rgba(0, 0, 0, 0.08) !Important', color: 'rgba(58, 58, 58, 1)' };
    }
};

export default function PayoutListDetail({ hideTotal }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const selectedRow = location?.state?.state?.data;
    const customerName = selectedRow?.customer || '-';
    const color = {
        color: 'rgba(76, 78, 100, 0.87)'
    }

    const [openPayout, setOpenPayout] = useState(false);
    const [historyDetailRow, setHistoryDetailRow] = useState(null);
    const [reference_id, setReference_id] = useState('');
    const [statusPaid, setStatusPaid] = useState('');
    const [payment_date, setPayment_date] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [comment, setComment] = useState('');
    const [readOnlyPayout, setReadOnlyPayout] = useState(false);
    const [netRevenue, setNetRevenue] = useState(null);

    // Paid / On-Hold rows are already finalised — show their values in the
    // modal but lock everything; other statuses open an empty editable form.
    const openActionForRow = (row) => {
        const raw = row.raw || row;
        const status = raw?.status;
        const locked = status === 'Paid' || status === 'On-Hold';
        if (locked) {
            setReference_id(raw?.reference_id || '');
            setStatusPaid(status || '');
            setPayment_date(raw?.payment_date ? dayjs(raw.payment_date) : null);
            setPaymentMethod(raw?.payout_type || '');
            setComment(raw?.comment || '');
        } else {
            setReference_id('');
            setStatusPaid('');
            setPayment_date(null);
            setPaymentMethod('');
            setComment('');
        }
        setReadOnlyPayout(locked);
        setHistoryDetailRow(raw);
        setOpenPayout(true);
    };

    const publisherId = selectedRow?.raw?.publisher_id;

    useEffect(() => {
        if (!publisherId) return;
        dispatch(setLoader(true));
        ApiService.get('studioDetail', {}, publisherId).then((res) => {
            if (res?.status === 200) {
                setNetRevenue(res?.data?.net_revenue ?? null);
            }
        }).catch(() => {}).finally(() => dispatch(setLoader(false)));
    }, [publisherId]);

    const viewDetails = () => {

    }

    const submitRequest = () => {
        const formData = new FormData();
        formData.append('status', statusPaid);
        formData.append('payment_date', payment_date);
        formData.append('reference_id', reference_id);
        formData.append('payout_type', paymentMethod);
        formData.append('comment', comment);

        dispatch(setLoader(true));
        ApiService.put('payout_status', formData, null, historyDetailRow?.id)
            .finally(() => {
                setOpenPayout(false);
                dispatch(setLoader(false));
                history.push('/payout');
            });
    }

    const rows = selectedRow ? [selectedRow] : [];

    const columns = [
        {
            id: 'customer', label: 'CUSTOMER', headerName: '', template: (row) => {
                return (
                    <Box className='d-flex gap-2 align-items-center cursorPointer' onclick={() => viewDetails()} ><img src={labels} alt='label-icon' />{row.customer}</Box>
                )
            }
        },
        { label: 'PAYMENT TYPE', field: "payment_type", id: 'payment_type' },
        {
            id: 'requested_date', label: 'REQUESTED DATE & TIME', headerName: '',
            template: (row) => <Box sx={{ whiteSpace: 'nowrap' }}>{row.requested_date}</Box>
        },
        {
            id: 'payment_date', label: 'PAYMENT DATE & TIME', headerName: '',
            template: (row) => <Box sx={{ whiteSpace: 'nowrap' }}>{row.payment_date}</Box>
        },
        {
            id: 'requested_amt', label: 'REQUESTED AMOUNT', headerName: '', flex: 1, template: (row) => {
                return (
                    <Typography variant='h6' ><CurrencyRupeeIcon fontSize={'small'} />{row.requested_amt}</Typography >
                )
            }
        },
        {
            id: 'status', label: 'STATUS', headerName: '', flex: 1, template: (row) => {
                return (
                    <Button className='text-capitalize rounded-pill px-3' sx={{ ...getStatusChipStyle(row.status), fontSize: 12, whiteSpace: 'nowrap', minWidth: 'auto' }}>{row.status}</Button>
                )
            }
        },
        {
            id: 'action', label: 'ACTION', headerName: '', flex: 1, template: (row) => {
                const disabled = netRevenue != null && parseFloat(netRevenue) <= 0;
                return (
                    <Tooltip title={disabled ? 'Net revenue is 0 — cannot create payout' : ''}>
                        <Box
                            className={`text-decoration-none viewDetailgradient ${disabled ? '' : 'cursorPointer'}`}
                            sx={disabled ? { opacity: 0.4, cursor: 'not-allowed' } : {}}
                            onClick={disabled ? undefined : () => openActionForRow(row)}
                        >
                            <MoreVertIcon />
                        </Box>
                    </Tooltip>
                )
            }
        }
    ];

    return (
        <Box className="py-3 px-4">
            <Typography variant='h5' className='cursorPointer d-flex align-items-center gap-2' sx={{ fontSize: '20px', fontWeight: '500' }} onClick={() => history.push('/payout')}><ArrowBackIcon /> {customerName} Account Detail </Typography>
            <Grid container spacing={2} className='mt-0'>
                <Grid item xs={12} md={6}>
                    <Box className="bg-white shadow-sm rounded" minHeight="230px">
                        <Box className='px-3 py-3'><Typography style={color} variant='h6' >{'Account'}</Typography ></Box>
                        <Divider />
                        <Box className="d-flex">
                            <Box className='align-items-center justify-content-evenly w-50 d-flex flex-column'>
                                <Box className=" d-flex align-items-center justify-content-center gap-2">
                                    <img src={currentbalance} alt='currentbalance' />
                                    <Box>
                                        <Typography style={color} variant='h4' ><CurrencyRupeeIcon fontSize={'large'} />{netRevenue ?? '00'}</Typography >
                                        <Typography style={{ ...color, fontSize: 14 }} variant='span' >{'Your Current Balance'}</Typography >
                                    </Box>
                                </Box>
                            </Box>
                            <Divider sx={{ height: '165px !important' }} orientation="vertical" flexItem />
                            <Box className="w-50 d-flex flex-column justify-content-center">
                                <Box className="d-flex align-items-center gap-2 pb-3 ps-3">
                                    <img src={rupee} alt='rupee' />
                                    <Box>
                                        <Typography style={color} variant='h6' ><CurrencyRupeeIcon fontSize={'small'} />{'00'}</Typography >
                                        <Typography style={{ ...color, fontSize: 14 }} variant='span' >{'Available Balance'}</Typography >
                                    </Box>
                                </Box>
                                <Divider />
                                <Box className="d-flex align-items-center gap-2 pt-2 ps-3 ">
                                    <img src={rupee1} alt='rupee' />
                                    <Box>
                                        <Typography style={color} variant='h6' ><CurrencyRupeeIcon fontSize={'small'} />{'00'}</Typography >
                                        <Typography style={{ ...color, fontSize: 14 }} variant='span' >{'Pending'}</Typography >
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>

                </Grid>
            </Grid>

            {/* <Typography variant='h5' className='' >Payout</Typography> */}
            {/* <BreadcrumbsList /> */}
            <Paper sx={{ width: '100%', mb: 2, mt: 3 }}>
                <TableComponent removeStyle='removeStyle' columns={columns} data={rows} totalCount={rows.length} page={page} setPage={setPage} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} />
            </Paper>
            <PayoutModal
                payoutAmount={historyDetailRow}
                open={openPayout}
                payment_date={payment_date}
                setPayment_date={setPayment_date}
                setReference_id={setReference_id}
                reference_id={reference_id}
                handleClose={() => setOpenPayout(false)}
                submitRequest={submitRequest}
                statusPaid={statusPaid}
                setStatusPaid={setStatusPaid}
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                comment={comment}
                setComment={setComment}
                readOnly={readOnlyPayout}
            />
        </Box>
    );
}
